import { render } from "./p.vue?vue&type=template&id=fccd1772&scoped=true&ts=true"
import script from "./p.vue?vue&type=script&lang=ts"
export * from "./p.vue?vue&type=script&lang=ts"

import "./p.vue?vue&type=style&index=0&id=fccd1772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fccd1772"]])

export default __exports__